<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface NoDataProps {
  title?: string
  message?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { FolderOpenIcon } from '@heroicons/vue/24/outline'
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '#ui-kit/ui/empty'

const props = withDefaults(defineProps<NoDataProps>(), {
  title: 'No data',
  message: 'There is no data to display',
})
</script>

<template>
  <Empty :class="props.class">
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <FolderOpenIcon aria-hidden="true" />
      </EmptyMedia>

      <EmptyTitle>{{ title }}</EmptyTitle>

      <EmptyDescription v-if="message">{{ message }}</EmptyDescription>
    </EmptyHeader>
  </Empty>
</template>
